var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shop"}},[_c('keep-alive',{attrs:{"include":['SearchResults', 'ProductListing'],"max":2}},[_c('router-view',{key:_vm.$route.params.product + ' ' + _vm.$route.params.subcategory + ' ' + _vm.$route.params.category})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }